<template>
  <Teleport to="body">
    <div class="fixed top-4 right-4 z-[100] flex flex-col gap-3 max-w-sm w-full pointer-events-none" aria-live="polite">
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          :class="toastClasses(toast.variant)"
          class="pointer-events-auto flex items-start gap-3 p-4 rounded-xl glass-card shadow-glass-lg animate-slide-down"
          role="status"
        >
          <component :is="iconFor(toast.variant)" class="h-5 w-5 shrink-0 mt-0.5" />
          <div class="flex-1 min-w-0">
            <p v-if="toast.title" class="font-medium text-sm">{{ toast.title }}</p>
            <p v-if="toast.message" class="text-sm opacity-90">{{ toast.message }}</p>
          </div>
          <button
            type="button"
            class="shrink-0 opacity-60 hover:opacity-100"
            aria-label="Dismiss notification"
            @click="removeToast(toast.id)"
          >
            <X class="h-4 w-4" />
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script>
import { CheckCircle, AlertCircle, AlertTriangle, Info, X } from '@lucide/vue'
import { useToast } from '@/composables/useToast'

export default {
  name: 'ToastContainer',
  components: { X },
  setup() {
    const { toasts, removeToast } = useToast()
    return { toasts, removeToast }
  },
  methods: {
    iconFor(variant) {
      return { success: CheckCircle, danger: AlertCircle, warning: AlertTriangle, info: Info }[variant] || Info
    },
    toastClasses(variant) {
      const map = {
        success: 'bg-surface border-success/30 text-foreground',
        danger: 'bg-surface border-danger/30 text-foreground',
        warning: 'bg-surface border-warning/30 text-foreground',
        info: 'bg-surface border-info/30 text-foreground',
      }
      return map[variant] || map.info
    },
  },
}
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
